import { useState, useEffect } from "react";

import { RiWhatsappLine } from "react-icons/ri";
import Form from "V2.0/components/Form";
import Joi from "joi-browser";
import httpService from "V2.0/services/httpService";
import {
  sheetURLFieldSchema,
  sheetURLFieldTemplate,
} from "V2.0/HomePages/HomeCampaign/bulkUpload/fields/sheetURLField";
import { triggerTypeField } from "../../../common/fields";

export default function BulkMetaWhatsAppCampaignForm(props) {
  const {
    createBulkCampaign,
    loading,
    setLoading,
    onClose,
    workspaceId,
    fromNumber,
    assistantId,
    name,
    description,
    ignorePreviousCampaigns,
  } = props;
  const [messageTemplates, setMessageTemplates] = useState([]);

  const inputField = {
    sheetURL: "",
    name,
    description,
    fromNumber,
    triggerType: "",
    campaignType: "whatsapp",
    template: JSON.stringify({
      templateName: "",
      templateLanguage: "",
    }),
    assistantId,
    ignorePreviousCampaigns,
  };

  const [errorMessage] = useState({});

  const fetchWhatsappMessageTemplates = async () => {
    try {
      const response = await httpService.get(
        `/whatsapp/manage/whitelabelGetTemplates/${workspaceId}`
      );
      const data = response.data;
      const templateNames = data.map((template) => ({
        templateName: template.name,
        templateLanguage: template.language,
      }));
      setMessageTemplates(templateNames);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchWhatsappMessageTemplates();
  }, []);

  const template = [
    sheetURLFieldTemplate,
    {
      name: "template",
      label: "Message Template",
      description: "Select one of the pre approved templates",
      type: "select",
      options: [
        { id: 0, value: JSON.stringify({}), label: "(No template selected)" },
      ].concat(
        messageTemplates.map((messageTemplate, index) => ({
          id: index,
          value: JSON.stringify(messageTemplate),
          label: messageTemplate.templateName,
        }))
      ),
    },
    triggerTypeField,
  ];

  const schema = {
    ...sheetURLFieldSchema,
    name: Joi.string().required().label("Campaign Name"),
    description: Joi.string().allow(null, "").label("Campaign Description"),
    template: Joi.object({
      templateName: Joi.string().required(),
      templateLanguage: Joi.string().required(),
    })
      .required()
      .label("Message Template"),
    fromNumber: Joi.string()
      .regex(/^\+?[0-9]+$/)
      .required()
      .label("From Number"),
    triggerType: Joi.string().required().label("Trigger Type"),
    campaignType: Joi.string().required().label("campaignType"),
    assistantId: Joi.string().required(),
    ignorePreviousCampaigns: Joi.boolean(),
  };

  function handleSubmit(data) {
    const { template, ...rest } = data;
    const { templateName, templateLanguage } = JSON.parse(template);

    const updatedData = {
      ...rest,
      templateName,
      templateLanguage,
    };

    createBulkCampaign(updatedData);
  }

  return (
    <Form
      key={JSON.stringify(inputField)}
      errorMessage={errorMessage}
      inputField={inputField}
      template={template}
      schema={schema}
      buttonInfo={{
        style: "",
        buttons: "2",
        // primaryLabel: "Start", // plain string label — replaced with icon+text matching the
        // channel, per Frontend's pattern (bulk-campaign-report-ui-port, Task 7)
        primaryLabel: (
          <>
            <RiWhatsappLine className="size-4" />
            Start WhatsApp Campaign
          </>
        ),
        secondaryLabel: "Cancel",
      }}
      onSubmit={handleSubmit}
      loading={loading}
      setLoading={setLoading}
      handleSecondary={onClose}
    />
  );
}
